import WithGASetup from '../../../components/WithGASetup';
import AuthContext from '../../../context/AuthContext.js';
import MyAppointmentsPage from './MyAppointmentsPage.js';

export default WithGASetup(MyAppointmentsPage, AuthContext);
